import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { OptionOrderList } from './_interfaces_/option-order-list.interface';
import { UrlService } from '../url/url.service';
import { UrlEnum } from 'src/app/core/enums/url.enum';
import { OrderDetailsMapped, OrderCancellationResponse } from './_interfaces_/option-order-details.mapped.interface';
import { OptionOrderMapperService } from './option-order-mapper.service';
import { OptionOrderDetails } from './_interfaces_/option-order-details.interface';
import { OrderMapped } from '../order/_interfaces_/order.mapped.interface';
import { LocalStorageService } from '../local-storage/local-storage.service';
import { OrderConfirmationPage } from '@pages/order-confirmation/_interfaces_/order-confirmation.interface';

@Injectable({
  providedIn: 'root',
})
export class OptionOrderService {
  constructor(
    @Inject(HttpClient) private _http: HttpClient,
    @Inject(LocalStorageService) private _localStorageService: LocalStorageService,
    @Inject(UrlService) private _urlService: UrlService,
    @Inject(OptionOrderMapperService) private _mapper: OptionOrderMapperService
  ) {}

  getOptionOrderList(): Observable<OrderMapped[]> {
    const url = this._urlService.urls[UrlEnum.GET_OPTION_ORDER_LIST];
    const sessionId = this._localStorageService.getUserSessionToken();
    const headers = { SessionId: sessionId };
    return this._http.get<OptionOrderList>(url, { headers }).pipe(map((data) => this._mapper.mapOptionOrders(data.orders)));
  }

  getOptionOrder(id: string): Observable<OrderDetailsMapped> {
    const url = `${this._urlService.urls[UrlEnum.GET_OPTION_ORDER_DETAILS]}?orderId=${id}`;
    const sessionId = this._localStorageService.getUserSessionToken();
    const headers = { SessionId: sessionId };
    return this._http.get<OptionOrderDetails>(url, { headers }).pipe(map((data) => this._mapper.mapOrderDetails(data)));
  }

  cancelOptionOrder(id: string): Observable<OrderCancellationResponse> {
    const url = `${this._urlService.urls[UrlEnum.DELETE_OPTION_ORDER]}?orderId=${id}`;
    const sessionId = this._localStorageService.getUserSessionToken();
    const headers = { SessionId: sessionId };
    return this._http.delete<OrderCancellationResponse>(url, { headers });
  }

  finalizeOptionOrder(id: string): Observable<OrderConfirmationPage> {
    const url = `${this._urlService.urls[UrlEnum.FINALIZE_OPTION_ORDER]}?orderId=${id}`;
    const sessionId = this._localStorageService.getUserSessionToken();
    const headers = { SessionId: sessionId };
    return this._http.get<OrderConfirmationPage>(url, { headers });
  }
}
